import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Amplitude } from '@/amplitude';
import { App } from '@/app/App';

import './styles/antd-override.css';
import './styles/index.css';
import './styles/panda.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Amplitude />
    <App />
  </StrictMode>,
);
